// extracted by mini-css-extract-plugin
module.exports = {"error":"styles_error__3jbVr","error__content":"styles_error__content__1Rlx2","error__image":"styles_error__image__31WIb","error__description":"styles_error__description__BcPgg"};